export const ErrorMessage = (properties) => {
  const {
    message,
  } = properties;
  return (<>
    <section className="error-message">
      <span className="message">{message}</span>
    </section>
  </>);
};
